<template>
    <div
        v-show="active"
        class="absolute top-full z-10 pt-1.5 lg:pt-2.5 min-w-[335px] xss:min-w-[353px] sm:min-w-[310px]"
        :class="classes"
    >
        <div class="bg-white rounded-xl border border-brand-2-950/10 shadow-4xl">
            <div
                v-if="title"
                class="flex items-center justify-between border-b border-brand-2-950/10 px-3 sm:px-5 py-2 sm:py-3"
            >
                <p
                    class="mt-1 text-xsss sm:text-xs font-semibold text-brand-2-950 leading-none"
                    v-text="title"
                ></p>

                <ClearButtonAlt @click.prevent="close" />
            </div>

            <div class="p-3 sm:p-5">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    import ClearButtonAlt from '@js/src/components/ClearButtonAlt.vue';

    const props = defineProps([
        'active',
        'title',
        'placement',
    ]);

    const emits = defineEmits([
        'close',
    ]);

    const classes = computed(() => {
        if (props.placement == '5xl-right') {
            return 'right-0 5xl:left-1/2 5xl:-translate-x-1/2';
        }

        if (props.placement == 'sm-left') {
            return 'left-0 sm:left-1/2 sm:-translate-x-1/2';
        }

        return 'left-1/2 -translate-x-1/2';
    });

    function close() {
        emits('close');
    }
</script>
